import React from "react"
import {theme} from "activities/theme"

export const ThemeContext = React.createContext(theme)
